import "../../utils/tailwind.css";
import { PageProvider, usePageProvider } from "./provider";
import Section from "../../components/section";
import React from "react";
import { Accordion } from "react-bootstrap";
import { Formik, Form, FieldArray } from "formik";
import { FormikInput } from "../../components/input";
import Plus from "../../components/svg/plus";
import Label from "../../components/label";
import Trash from "../../components/svg/trash";
import ImageUploader from "../../components/upload-image";
import Button from "../../components/Buttons";
import ReactQuill from "react-quill";
import { FormikTextarea } from "../../components/textarea";
import { FormikDropdown } from "../../components/dropdown";
import { FormikSwitch } from "../../components/switch";

export default function AddUser() {
  return (
    <div className="p-3 bg-[#fffbf4] ">
      <PageProvider>
        <PageContent />
      </PageProvider>
    </div>
  );
}

function PageContent() {
  const {
    initialValues,
    handleUserImagesAdd,
    monialsRef,
    getFaqQuery,
    userImagesArray,
    levelUpsArrayRef,
    handleLevelUpAdd,
    handleLevelUpDelete,
    handleSubmit,
    updateHomeQuery,
  } = usePageProvider();

  return (
    <Section>
      <Formik initialValues={initialValues} onSubmit={handleSubmit} enableReinitialize>
        {({ values, setFieldValue }) => (
          <Form>
            <Accordion defaultActiveKey="0" className="mt-5">
              <Accordion.Item eventKey="1" className="w-[100%]  ml-[1rem] ">
                <Accordion.Header>SEO META</Accordion.Header>
                <Accordion.Body>
                  <div className="grid grid-cols-1 sm:grid-cols-3 gap-3">
                    <div className="flex flex-col">
                      <Label label="Meta Title" className="mb-2 text-black text-[15px] font-semibold" />
                      <FormikInput name="meta_seo.meta_title" rootClassName="w-full" />
                    </div>
                    <div className="flex flex-col">
                      <Label label="Meta Keywords" className="mb-2 text-black text-[15px] font-semibold" />
                      <FormikInput name="meta_seo.meta_keyword" rootClassName="w-full" />
                    </div>

                    <div className="flex flex-col">
                      <Label label="Meta Description" className="mb-2 text-black text-[15px] font-semibold" />
                      <FormikInput name="meta_seo.meta_desc" rootClassName="w-full" />
                    </div>
                  </div>
                </Accordion.Body>
              </Accordion.Item>

              <Accordion.Item eventKey="2" className="w-[100%]  ml-[1rem] ">
                <Accordion.Header>Header</Accordion.Header>
                <Accordion.Body>
                  <Accordion>
                    <Accordion.Item eventKey="19">
                      <Accordion.Header>Banner Details</Accordion.Header>
                      <Accordion.Body>
                        <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
                          <div className="flex flex-col">
                            <Label label="Primary Heading" className="mb-2 text-black text-[15px] font-semibold" />
                            <FormikInput name="header.primary_heading" rootClassName="w-full" />
                          </div>

                          <div className="flex flex-col ">
                            <Label label="Secondery Heading" className="mb-2 text-black text-[15px] font-semibold" />
                            <FormikInput name="header.secondary_heading" rootClassName="w-full" />
                          </div>
                        </div>
                        <div className="flex flex-col mt-2">
                          <Label label="Description" className="mb-2 text-black text-[15px] font-semibold" />
                          <FormikTextarea name="header.description" rootClassName="w-full" as="textarea" />
                        </div>
                      </Accordion.Body>
                    </Accordion.Item>
                  </Accordion>

                  <Accordion className="mt-2">
                    <Accordion.Item eventKey="20">
                      <Accordion.Header>CTA Buttons</Accordion.Header>
                      <Accordion.Body>
                        <div className="grid grid-cols-1 sm:grid-cols-4 gap-3">
                          <div className="flex flex-col">
                            <Label label="CTA Label" className="mb-2 text-black text-[15px] font-semibold" />
                            <FormikInput name="header.primary_cta.label" rootClassName="w-full" />
                          </div>
                          <div className="flex flex-col">
                            <Label label="CTA Redirect link" className="mb-2 text-black text-[15px] font-semibold" />
                            <FormikInput name="header.primary_cta.redirect_link" rootClassName="w-full" />
                          </div>

                          <div className="flex flex-col">
                            <Label label="Secondery CTA Label" className="mb-2 text-black text-[15px] font-semibold" />
                            <FormikInput name="header.secondary_cta.label" rootClassName="w-full" />
                          </div>
                          <div className="flex flex-col">
                            <Label label="Secondery Redirect link" className="mb-2 text-black text-[15px] font-semibold" />
                            <FormikInput name="header.secondary_cta.redirect_link" rootClassName="w-full" />
                          </div>
                        </div>
                      </Accordion.Body>
                    </Accordion.Item>
                  </Accordion>
                </Accordion.Body>
              </Accordion.Item>

              <Accordion.Item eventKey="3" className="w-[100%]  ml-[1rem] ">
                <Accordion.Header>Tech Section</Accordion.Header>
                <Accordion.Body>
                  <div className="flex justify-end mt-3">
                    <div className=" bg-[#7C13CA] p-1 rounded-full w-auto cursor-pointer ">
                      <Plus onClick={handleUserImagesAdd} className={" text-[white]"} />
                    </div>
                  </div>

                  <div className="mt-3 overflow-x-auto">
                    <table className="w-full table-fixed border-collapse border border-gray-300">
                      <tbody>
                        <tbody>
                          <FieldArray
                            name="tech_section"
                            render={(arrayHelpers) => {
                              userImagesArray.current = arrayHelpers;

                              return (
                                <div className="space-y-6">
                                  {values?.tech_section?.map((item, index) => (
                                    <table key={`row-${index}`} className="w-full table-fixed border-collapse border border-gray-300">
                                      <thead className="bg-gray-200">
                                        <tr>
                                          <th className="w-[20%] font-normal border px-2 py-2">Title</th>
                                          <th className="w-[20%] font-normal border px-2 py-2">Alt Tag</th>
                                          <th className="w-[20%] font-normal border px-2 py-2">Image</th>
                                          <th className="w-[5%] font-normal border px-2 py-2 text-center">Action</th>
                                        </tr>
                                      </thead>
                                      <tbody>
                                        <tr>
                                          <td className="border px-2 py-2">
                                            <FormikInput name={`tech_section.${index}.title`} rootClassName="w-full" />
                                          </td>
                                          <td className="border px-2 py-2">
                                            <FormikInput name={`tech_section.${index}.alt_tag`} rootClassName="w-full" />
                                          </td>
                                          <td className="border px-2 py-2">
                                            <ImageUploader
                                              title="Desktop"
                                              imageUrl={item.desktop_image_url}
                                              onChange={(res) => setFieldValue(`tech_section.${index}.desktop_image_url`, res?.data?.file_url)}
                                            />
                                          </td>
                                          <td className="border px-2 py-2 text-center" rowSpan={2}>
                                            <div
                                              className="flex justify-center items-center cursor-pointer h-full"
                                              onClick={() => arrayHelpers.remove(index)}
                                            >
                                              <Trash />
                                            </div>
                                          </td>
                                        </tr>

                                        <tr>
                                          <td colSpan={3} className="border px-2 py-2">
                                            <label className="block text-gray-700 text-sm font-semibold mb-2">Description</label>
                                            <ReactQuill
                                              theme="snow"
                                              value={item.description}
                                              onChange={(e) => setFieldValue(`tech_section.${index}.description`, e)}
                                            />
                                          </td>
                                        </tr>
                                      </tbody>
                                    </table>
                                  ))}
                                </div>
                              );
                            }}
                          />
                        </tbody>
                      </tbody>
                    </table>
                  </div>
                </Accordion.Body>
              </Accordion.Item>

              <Accordion.Item eventKey="4" className="w-[100%] ml-[1rem]  ">
                <Accordion.Header>Level Up Your Training With Gyaankool</Accordion.Header>
                <Accordion.Body>
                  <Accordion>
                    <Accordion.Item eventKey="19">
                      <Accordion.Header>Levels Details</Accordion.Header>
                      <Accordion.Body>
                        <div className="grid grid-cols-1 sm:grid-cols-1 gap-3">
                          <div className="flex flex-col">
                            <Label label="Heading" className="mb-2 text-black text-[15px] font-semibold" />
                            <FormikInput name="training_level_up.heading" rootClassName="w-full" />
                          </div>
                        </div>
                        <div className="flex flex-col mt-2">
                          <Label label="Description" className="mb-2 text-black text-[15px] font-semibold" />
                          <FormikTextarea name="training_level_up.description" rootClassName="w-full" as="textarea" />
                        </div>
                      </Accordion.Body>
                    </Accordion.Item>
                  </Accordion>

                  <Accordion className="mt-2">
                    <Accordion.Item eventKey="29" className="mb-4">
                      <Accordion.Header>Level Up Information</Accordion.Header>
                      <Accordion.Body>
                        <div className="grid grid-cols-1 sm:grid-cols-3 gap-3">
                          <div className="flex flex-col">
                            <Label label="Header One" className="mb-2 text-black text-[15px] font-semibold" />
                            <FormikInput name="training_level_up.level_up_information.header_one" rootClassName="w-full" />
                          </div>
                          <div className="flex flex-col">
                            <Label label="Header Two" className="mb-2 text-black text-[15px] font-semibold" />
                            <FormikInput name="training_level_up.level_up_information.header_two" rootClassName="w-full" />
                          </div>

                          <div className="flex flex-col">
                            <Label label="Header Third" className="mb-2 text-black text-[15px] font-semibold" />
                            <FormikInput name="training_level_up.level_up_information.header_three" rootClassName="w-full" />
                          </div>
                        </div>

                        <div className="flex justify-end mt-3">
                          <div className="bg-[#7C13CA] p-1 rounded-full w-auto cursor-pointer" onClick={handleLevelUpAdd}>
                            <Plus className="text-white" />
                          </div>
                        </div>

                        <FieldArray name="training_level_up.level_up_information.level_ups">
                          {(arrayHelpers) => {
                            levelUpsArrayRef.current = arrayHelpers;

                            return (
                              <div className="mt-3 overflow-x-auto">
                                <table className="w-full table-fixed border-collapse border border-gray-300">
                                  <thead className="bg-gray-200">
                                    <tr>
                                      <th className="w-[30%] border font-normal border-gray-300 px-2 py-2 text-left">Title</th>
                                      <th className="w-[30%] border font-normal border-gray-300 px-2 py-2 text-left">Column 1</th>
                                      <th className="w-[30%] border font-normal border-gray-300 px-2 py-2 text-left">Column 2</th>
                                      <th className="w-[10%] border font-normal border-gray-300 px-2 py-2 text-center">Action</th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    {values?.training_level_up?.level_up_information?.level_ups?.map((_, index) => (
                                      <tr key={index}>
                                        <td className="border border-gray-300 px-4 py-2">
                                          <FormikInput
                                            name={`training_level_up.level_up_information.level_ups.${index}.basis`}
                                            rootClassName="w-full"
                                          />
                                        </td>
                                       
                                        <td className="border border-gray-300 px-2 py-2">
                                          <FormikSwitch  name={`training_level_up.level_up_information.level_ups.${index}.before`}
                                            rootClassName="w-full" />
                                        </td>
                                        <td className="border border-gray-300 px-4 py-2">
                                          <FormikSwitch
                                            name={`training_level_up.level_up_information.level_ups.${index}.after`}
                                            rootClassName="w-full"
                                          />
                                        </td>
                                        <td className="border border-gray-300 px-4 py-2">
                                          <div className="flex justify-center cursor-pointer" onClick={handleLevelUpDelete(index)}>
                                            <Trash />
                                          </div>
                                        </td>
                                      </tr>
                                    ))}
                                  </tbody>
                                </table>
                              </div>
                            );
                          }}
                        </FieldArray>
                      </Accordion.Body>
                    </Accordion.Item>
                  </Accordion>
                </Accordion.Body>
              </Accordion.Item>

              <Accordion.Item eventKey="6" className="w-[100%]  ml-[1rem]  ">
                <Accordion.Header>Ready to Launch?</Accordion.Header>
                <Accordion.Body>
                  <div className="grid grid-cols-1 sm:grid-cols-4 gap-3">
                    <div className="flex flex-col">
                      <Label label="Heading" className="mb-2 text-black text-[15px] font-semibold" />
                      <FormikInput name="ready_to_launch.heading" rootClassName="w-full" />
                    </div>
                    <div className="flex flex-col">
                      <Label label="SubHeading" className="mb-2 text-black text-[15px] font-semibold" />
                      <FormikInput name="ready_to_launch.subheading" rootClassName="w-full" />
                    </div>
                    <div className="flex flex-col">
                      <Label label="CTA Label" className="mb-2 text-black text-[15px] font-semibold" />
                      <FormikInput name="ready_to_launch.primary_cta.label" rootClassName="w-full" />
                    </div>
                    <div className="flex flex-col">
                      <Label label="CTA Redirect link" className="mb-2 text-black text-[15px] font-semibold" />
                      <FormikInput name="ready_to_launch.primary_cta.redirect_link" rootClassName="w-full" />
                    </div>
                  </div>

                  <div className="grid grid-cols-1 sm:grid-cols-3 gap-3 mt-3">
                   <div className="flex flex-col">
                      <Label label="Video URL" className="mb-2 text-black text-[15px] font-semibold" />
                      <FormikInput name="ready_to_launch.video_url" rootClassName="w-full" />
                    </div>
                    <div className="flex flex-col">
                      <Label label="Alt Tag" className="mb-2 text-black text-[15px] font-semibold" />
                      <FormikInput name="ready_to_launch.alt_tag" rootClassName="w-full" />
                    </div>
                    
                     <div className="flex flex-col">
                      <Label label="Thumbnail Image" className="mb-2 text-black text-[15px] font-semibold" />
                      <ImageUploader
                        className="w-full"
                        title="image"
                        name="ready_to_launch.video_overlay_img"
                        imageUrl={values?.ready_to_launch?.video_overlay_img}
                        onChange={(res) => {
                          setFieldValue(`ready_to_launch.video_overlay_img`, res?.data?.file_url);
                        }}
                      />
                    </div>
                  </div>

                  <div className="flex flex-col">
                    <Label label="Description" className="mb-2 text-black text-[15px] font-semibold" />
                    <FormikInput name="ready_to_launch.description" rootClassName="w-full" as="textarea" />
                  </div>
                </Accordion.Body>
              </Accordion.Item>

              <Accordion.Item eventKey="7" className="w-[100%] ml-[1rem] mb-8">
                <Accordion.Header>FAQ's</Accordion.Header>
                <Accordion.Body>
                  <div className="grid grid-cols-1 sm:grid-cols-1 gap-3">
                    <div className="flex flex-col">
                      <Label label="FAQ Heading" className="mb-2 text-black text-[15px] font-semibold" />
                      <FormikInput name="testimonials.heading" rootClassName="w-full" />
                    </div>
                  </div>
                  <div className="flex justify-end my-3">
                    <div className="bg-[#7C13CA] p-1 rounded-full w-auto cursor-pointer" onClick={() => monialsRef?.current?.push({ faq: "" })}>
                      <Plus className="text-white" />
                    </div>
                  </div>

                  <FieldArray name="testimonials.testimonials">
                    {(arrayHelpers) => {
                      monialsRef.current = arrayHelpers;

                      return (
                        <div className="mt-2 overflow-x-auto">
                          <table className="w-full table-fixed border-collapse border border-gray-300">
                            <thead className="bg-gray-200">
                              <tr>
                                <th className="w-[94%] border font-normal border-gray-300 px-2 py-2 text-left">Faq</th>
                                <th className="w-[6%] border font-normal border-gray-300 px-2 py-2 text-center">Action</th>
                              </tr>
                            </thead>
                            <tbody>
                              {values?.testimonials?.testimonials?.map((item, index) => (
                                <tr key={index}>
                                  <td className="border border-gray-300 px-4 py-2">
                                    <FormikDropdown
                                      options={getFaqQuery?.data?.data?.data?.map((item) => ({
                                        label: item.ques,
                                        value: item.id,
                                      }))}
                                      name={`testimonials.testimonials.${index}.faq`}
                                      rootClassName="w-full"
                                    />
                                  </td>
                                  <td className="border border-gray-300 px-4 py-2 text-center">
                                    <div className="flex justify-center cursor-pointer" onClick={() => monialsRef?.current?.remove(index)}>
                                      <Trash />
                                    </div>
                                  </td>
                                </tr>
                              ))}
                            </tbody>
                          </table>
                        </div>
                      );
                    }}
                  </FieldArray>
                </Accordion.Body>
              </Accordion.Item>
            </Accordion>

            <div className="fixed bottom-0 z-[999] left-0 w-full bg-[#fef5e4] flex justify-end items-center py-3 rounded-lg pr-4 space-x-3 shadow-md">
              <Button
                isLoading={updateHomeQuery?.isPending}
                type="submit"
                className="!border-none text-white rounded-md !bg-[#7C13CA] hover:!bg-[#ffd869] hover:!text-black transition-colors duration-200"
              >
                Save
              </Button>
            </div>
          </Form>
        )}
      </Formik>
    </Section>
  );
}
